// extracted by mini-css-extract-plugin
export default {"settingsPage":"Settings_settingsPage__X3SvL","settingsForm":"Settings_settingsForm__8h8ZG"};